import { refine, size, string } from 'superstruct';

import { userString } from './userString';
import { withMessage } from './withMessage';

/**
 * Validates a string with a maximum length. Allows empty strings.
 * Use this for optional string fields (e.g. items inside arrays).
 */
export const stringMaxLength = (maxLen: number, message?: string) =>
	withMessage(size(string(), 0, maxLen), message || 'validations:Max Length');

/**
 * Like userString, but also validates that the string length does not
 * exceed `maxLen`. Shows 'validations:Required' for empty/null values and
 * 'validations:Max Length' when the limit is exceeded.
 */
export const userStringWithMaxLength = (maxLen: number, message?: string) =>
	refine(userString('validations:Required'), 'maxLength', (value) => {
		const str = value;
		return str.length <= maxLen || message || 'validations:Max Length';
	});
